import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Tuesday, August 20, 2019`}</h1>
    <ul>
      <li parentName="ul">{`Deployed new `}<a parentName="li" {...{
          "href": "https://angelhacks.org"
        }}>{`AngelHacks site`}</a>{` (`}<a parentName="li" {...{
          "href": "https://github.com/angelhacks/site"
        }}>{`source code`}</a>{`)`}</li>
      <li parentName="ul">{`Added dark mode, site-wide AMP support, & added Hooks on `}<a parentName="li" {...{
          "href": "https://gasp.now.sh"
        }}>{`Gasp!`}</a></li>
      <li parentName="ul">{`Fixed reaction sorting on `}<a parentName="li" {...{
          "href": "https://hackclub-emoji.now.sh"
        }}>{`hackclub-emoji`}</a></li>
      <li parentName="ul">{`Minor updates to my `}<a parentName="li" {...{
          "href": "https://lachlanjc.me"
        }}>{`personal site`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      